import { marksContainerImageSX } from '@/components/blocks/DpLibrary/DpMark/style/container';
import { Img } from '@/components/blocks/MaterialImage';
import { Grid } from '@mui/material';

export const DpMarkIco = ({
	image,
	alt,
	loading,
	priority,
}: {
	image: string;
	alt?: string;
	loading?: 'lazy' | 'eager';
	priority?: boolean;
}) => (
	<Grid sx={marksContainerImageSX}>
		<Img
			src={image}
			alt={alt}
			sx={{
				maxWidth: '100px',
				'@media screen and (max-width: 768px)': {
					maxWidth: '80px',
				},
			}}
			loading={loading}
			priority={priority}
		/>
	</Grid>
);
